import { throttle } from 'lodash-es';

export const Header = (function () {
	'use strict';

	let header, lastScrollY, headerHeight, $menu, $menuButton, $subMenuParent, $subMenuItem, $body;

	function init() {
		($menu = $('.site-header__nav .nav-items')), ($menuButton = $('.mobile-menu-button'));
		$body = $('body');
		$subMenuParent = $('.site-header .menu-item-has-children');
		$subMenuItem = $('.site-header .sub-menu a');

		events();
		stickyHeader();
	}

	function events() {
		$menuButton.click(function () {
			if ($menu.hasClass('open')) {
				$body.removeClass('mobile-menu-open');
				$menu.removeClass('open');
				$menuButton.removeClass('open').attr('aria-expanded', 'false');
			} else {
				$body.addClass('mobile-menu-open');
				$menu.addClass('open');
				$menuButton.addClass('open').attr('aria-expanded', 'true');
			}
		});

		document.querySelectorAll('.nav-items > li > a').forEach((a) => {
			a.addEventListener('click', (ev) => {
				if (a.href.replace(window.location.protocol + '//' + window.location.host + '/', '').substr(0, 1) === '#') {
					$body.removeClass('mobile-menu-open');
					$menu.removeClass('open');
					$menuButton.removeClass('open').attr('aria-expanded', 'false');
				}
			});
		});
	}

	function stickyHeader() {
		if (document.querySelector('.site-header') === null) return;
		header = document.querySelector('.site-header');
		headerHeight = header.offsetHeight;
		document.body.style.padding = headerHeight + 'px 0px 0px';
		window.addEventListener(
			'scroll',
			throttle(() => {
				// console.log(window.scrollY, lastScrollY);
				window.scrollY < lastScrollY ? header.classList.add('site-header--appear') : header.classList.remove('site-header--appear');
				if (window.scrollY < 50) {
					header.classList.add('site-header--appear');
				}
				lastScrollY = window.scrollY;
			}, 100)
		);
	}

	return {
		init: init,
	};
})();
